import React from 'react';
import FailureScreen from '../FailureScreen/FailureScreen';

const abandonScreen = (props) => {
  let contentObj = {
    titleBold: 'פופאפ נטישה',
    description: 'טקסט של פופ אפ נטישה טקסט של פופ אפ נטישה טקסט של פופ אפ נטישה טקסט של פו',
    btnText: 'חזור לתהליך',
    bottomLinkText: 'לעמוד הבית',
    bottomLinkUrl: 'http://ynet.co.il',
  };

  return <FailureScreen object={contentObj} />;
};

export default abandonScreen;
